/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from "@emotion/react";
import { defaultTheme } from "styles/theme";

type Columns1to2to4WrapperProps = {
  firstComponent?: React.ReactNode;
  secondComponent?: React.ReactNode;
  thirdComponent?: React.ReactNode;
  fourthComponent?: React.ReactNode;
  cssOverride?: SerializedStyles;
};

export const Columns1to2to4Wrapper: React.FC<Columns1to2to4WrapperProps> = ({
  firstComponent,
  secondComponent,
  thirdComponent,
  fourthComponent,
  cssOverride,
}) => {
  return (
    <div
      css={[
        cssOverride,
        css`
          display: grid;

          grid-template-columns: repeat(1, 1fr);
          gap: ${defaultTheme.spacing.xs};
          @media screen and (min-width: ${defaultTheme.breakpoints.sm}) {
            grid-template-columns: repeat(2, 1fr);
            gap: ${defaultTheme.spacing.sm};
          }
          @media screen and (min-width: ${defaultTheme.breakpoints.lg}) {
            grid-template-columns: repeat(4, 1fr);
            gap: ${defaultTheme.spacing.sm};
          }
        `,
      ]}
    >
      <div>{firstComponent}</div>
      <div>{secondComponent}</div>
      <div>{thirdComponent}</div>
      <div>{fourthComponent}</div>
    </div>
  );
};
